import React, { createContext, useState, useContext } from 'react';

const AppContext = createContext();

export const useAppContext = () => useContext(AppContext);

export const AppProvider = ({ children }) => {
  const [contactFormOpen, setContactFormOpen] = useState(false);
  
  const value = {
    contactFormOpen,
    setContactFormOpen,
  };
  
  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};

export default AppContext;